import { Util } from '@grandvisionhq/common';
import { placeholderImage } from '@grandvisionhq/utils';

const imageSizes = {
    M: 171,
    L: 192,
    XL: 272,
    MAX: 544
};
// Default width and height to set the right aspect ratios 544/306 = 16:9
const defaultSettings = {
    fit: 'fill',
    format: 'jpeg',
    width: imageSizes.MAX,
    height: 306,
    aspectRatio: 16 / 9
};
const createResponsiveImage = (url, alt)=>{
    if (!url) {
        return {
            src: placeholderImage.url,
            alt: alt || ''
        };
    }
    return {
        src: Util.createImgUrl(url, defaultSettings),
        srcSet: Util.createImageSrcSet(url, imageSizes, defaultSettings),
        sizes: Util.createImageSizes(imageSizes, url),
        alt: alt || ''
    };
};

export { createResponsiveImage, defaultSettings };
//# sourceMappingURL=responsive-image.js.map
